export default __webpack_public_path__ + "static/media/scooter.c301bb43.ogg";